import ListPage from "../../../manager/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./user-groups.scss";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  }
];

const UserGroupList = () => {
  return (
    <div className="userGroupList">
      <ListPage
        title={"User groups"}
        defaultSortCol={"name"}
        columns={columns}
        dataUrl={{
          url: "user_groups",
          backend: "platform"
        }}
        deleteUrl={{
          url: "user_groups",
          backend: "platform"
        }}
      />
    </div>
  );
};

export default UserGroupList;